import React, { useState } from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter'
import Callback from './Callback';
import ShiftingProcess from './ShiftingProcess';
import WorkProcess from './WorkProcess';
import helpdeskdetails from "../images/Helpdesk.jpg";
import Contactform from './Contactfrom';
import Table from 'react-bootstrap/Table';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Bardhamanphoto from "../images/city-relocat.jpg";
import Callfrom from './Callfrom';

function Bardhaman() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 3
  };


  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />

      <ScrollToTop smooth top="100" color="Gray" />
      <div className='packermovershoogle'>
        <div className="album py-0">

          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#"><small>Home</small></Link></li>
                <li className="breadcrumb-item active" aria-current="page"><small>Bardhaman</small></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div style={{
        backgroundImage: "url(" + "https://i.postimg.cc/zGf7BK72/home-shifting-photo-copy.jpg" + ")",
        backgroundPosition: 'start',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>



        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-7 mt-3">
                <button className='iba mb-3'>IBA Approved Packers and Movers</button>
                   <div className='goldBardhaman'>
                <div className="album py-1">
                  <div className="container mt-3">
                    <div className="row">
                      <nav style={{ color: "white" }}  aria-label="breadcrumb">
                        <ol  style={{ color: "white" }}  className="breadcrumb">
                          <li style={{ color: "white" }} className="breadcrumb-item"><Link style={{ color: "white" }} to="/" > Home</Link></li>
        
                          <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page">Bardhaman</li>
        
                        </ol>
                      </nav>
                    </div>
        
                  </div>
                </div>
              </div>
                <h1 style={{ fontSize: "3rem", color: "white" }} className="card-text mb-4"> <b>Best Packers and Movers in Bardhaman
</b></h1>

             
                <div className="indiastrustedwebsitedevelopment">
                  <h3 style={{  color: "white" }} className="card-text mb-8 mt-2"> <b>প্যাকার্স অ্যান্ড মুভার্স পরিষেবার জন্য আমাদের সাথে যোগাযোগ করুন  -  8101278298</b></h3>
                </div>
              </div>
              <div className="col-md-5 mt-3">
                <div className='packer_Rajarhatkolkata'>
                  <Contactform />
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />



      </div>

      <div className='grey'>
        <br />
        <div className="album py-1">
        </div>
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-7 mt-3">
           <h2 className='mb-2'>Bardhaman, Bardhaman</h2>
           <h1>Bardhaman Packers and Movers</h1>
           <h6 className='justify'>Affordable Packers and Movers in Bardhaman – Get reliable, professional, and budget-friendly relocation services for a smooth move to or from Bardhaman.

Looking for trusted packers and movers in Bardhaman? We provide hassle-free shifting services with top-quality packing and on-time delivery.

Professional relocation services in Bardhaman at competitive rates – ensuring your move is safe, quick, and stress-free.

Choose our expert packers and movers in Bardhaman for seamless local and long-distance shifting with maximum convenience.

We deliver efficient and affordable moving services in Bardhaman designed to exceed your expectations every time.

Experience hassle-free packing and moving in Bardhaman with our skilled team and customized relocation solutions.

Our Bardhaman packers and movers ensure safe transportation of your belongings with professional care and precision.</h6>
              </div>
              <div className="col-md-5 mt-4">
                <div className="card" >
                  <img src={Bardhamanphoto} className="card-img-top" alt="Bardhaman"/>
                  
                </div>

              </div>
            </div>
          </div>
        </div>
        <br />
        <br />

      </div>
   
      <div className='homeshiftprice'>
           <br />
      <div className="container">
        <div className='welcometext'>
          <h1 className="card-title mb-0"><b>Check Our Affordable House Shifting Prices Below:

          </b></h1>
          <div className="col-md-10">
            <hr style={{ color: "#1D4D93" }} />
          </div>
        </div>
      </div>
      <div className="animat">
        <Slider {...settings}>

          <div>

            <div className="card mb-12">
              <Table striped bordered hover variant="light">
                <thead>
                  <tr>
                    <th style={{ color: "#0439b5ff" }}>Move Type/Distance	</th>
                    <th style={{ color: "#0335aaff" }}>100 - 350 km</th>
                    <th style={{ color: "#032062" }}>350 - 750 km</th>
                    <th style={{ color: "#032062" }}>750 - 1200 km</th>
                    <th style={{ color: "#032062" }}>1200 - 1700 km</th>
                    <th style={{ color: "#032062" }}>1700 - 2300 km	</th>
                    <th style={{ color: "#032062" }}>2300 - 3000 km</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 BHK</td>
                    <td>Rs. 11,000 - 21,000</td>
                    <td>	Rs. 13,500 - 22,500</td>
                    <td>Rs. 15,500 - 25,500</td>
                    <th>Rs. 18,500 - 27,000</th>
                    <th>Rs. 21,000 - 30,000</th>
                    <th>Rs. 23,500 - 36,700</th>


                  </tr>
                  <tr>
                    <td>2 BHK</td>
                    <td>Rs. 15,000 - 25,000</td>
                    <td>Rs. 17,500 - 28,500</td>
                    <td>Rs. 20,000 - 31,000</td>
                    <th>Rs. 23,000 - 36,000</th>
                    <th>Rs. 27,000 - 40,000</th>
                    <th>Rs. 29,300 - 46,000</th>

                  </tr>
                  <tr>
                    <td>3 BHK</td>
                    <td >Rs. 18,000 - 30,000</td>
                    <td>Rs. 21,000 - 34,000	</td>
                    <td>Rs. 23,500 - 38,000</td>
                    <th>Rs. 27,500 - 42,000</th>
                    <th>Rs. 32,000 - 48,000</th>
                    <th>Rs. 35,000 - 55,500</th>

                  </tr>




                  <tr>
                    <td>4+ BHK/Villa</td>
                    <td> Rs. 22,500 - 34,500</td>
                    <td>Rs. 26,000 - 39,000	</td>
                    <td>Rs. 29,000 - 45,000	</td>
                    <th>Rs. 34,000 - 47,500</th>
                    <th>Rs. 38,000 - 55,000</th>
                    <th>Rs. 41,000 - 60,000</th>


                  </tr>





                </tbody>
              </Table>

            </div>

          </div>

          <div>
            
           
          </div>

       


        
          <div>
          </div>

        </Slider>
      </div>
<br />
<br/>
</div>

<div className="album py-1">
          <div className="container">
            <h1 style={{color:"#05438e"}} className='mt-2'><b>Bardhaman packers movers near me</b></h1>
            <p style={{color:"#05438e"}}>If you are searching for ‘Packers Movers near me’ in Bardhaman, look no further — AT INDIA PACKERS MOVERS is your top choice, trusted by customers for reliable shifting services.</p>
            <h1 style={{color:"#05438e"}}><b>Best packers movers in Bardhaman</b></h1>
            <p style={{color:"#05438e"}}>AT INDIA PACKERS MOVERS in Bardhaman is recognized as one of the best packers and movers in the region, serving individuals, businesses, corporations, and government organizations with excellence.

Among the top-rated packers and movers, AT INDIA PACKERS MOVERS in Bardhaman offers reliable relocation services for a wide range of clients including households, companies, and government bodies.</p>
            
                   <button type="button" className="whatsapp mt-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      REQUEST CALL BACK
                    </button>

                    <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title packersmoverswebsite" id="exampleModalLabel">AT INDIA PACKERS</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div className="modal-body">
                            <Callfrom/>
                          </div>
                          <div className="modal-footer">
                            <button type="button" className="close" data-bs-dismiss="modal">Close</button>

                          </div>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <br/>
            </div>
          </div>

          <div className='Bardhamanpackers'>
            <div className="album py-1">
          <div className="container">
            <br/>
            <center>
                <h3 className='mb-3'><b>Frequently Asked Questions</b></h3>
            </center>
            <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <b>While shifting in Bardhaman, do I need to travel with the transport vehicle?</b>
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>Our team takes full responsibility for the safety of your belongings, and you’ll receive regular updates until delivery. If you prefer, you may accompany the vehicle, but it’s completely optional.</h6>
 


                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <b>In Bardhaman, is luggage insurance offered during shifting, and how is damage handled?</b>
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                  <h6>Yes, in Bardhaman we provide luggage insurance options during shifting to ensure extra protection for your belongings. In the rare event of any damage or loss, the claim process is initiated promptly, and compensation is provided as per the insurance policy terms. Our priority is to deliver your goods safely, but the insurance gives you additional peace of mind throughout the relocation.</h6>

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  <b>How should I pack and safeguard my belongings while shifting from Bardhaman?</b>
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>To ensure a smooth and safe move from Baguiati, you should properly prepare and protect your belongings. Start by decluttering and categorizing items to make packing easier. Use high-quality packing materials such as sturdy boxes, bubble wrap, and tape to safeguard fragile items. Label all boxes clearly and create an inventory list to keep track of your goods. Additionally, hire professional packers and movers, like AT INDIA PACKERS MOVERS, who handle packing, loading, and transportation with care, ensuring your belongings reach the destination safely and securely.</h6>
                </div>
              </div>
            </div>



            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  <b>How far in advance should I arrange for bike transportation in Bardhaman?</b>
                </button>
              </h2>
              <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                <h6>It is recommended to book your bike transportation in Bardhaman at least 3–5 days in advance to ensure availability and smooth scheduling. However, if you need urgent shifting, we also offer quick arrangements depending on vehicle and slot availability. Booking early helps us plan better and ensures a hassle-free relocation for your bike.</h6>

                </div>
              </div>
            </div>


            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFive">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  <b>What’s the average duration required for logistics moving in Bardhaman?</b>
                </button>
              </h2>
              <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                <div className="accordion-body">
               <h6>The average duration for logistics moving in Bardhaman depends on the volume of goods and the distance involved. For local shifting within Bardhaman, it usually takes a few hours to a single day. For larger or long-distance logistics moves, it may take 1–3 days. Our team ensures timely delivery with proper planning so your goods reach safely without delays..</h6>

                </div>
              </div>
            </div>

           
          </div>
            </div>
          </div>
          </div>

   
      <ShiftingProcess />


      <Callback />


    </div>
  )
}

export default Bardhaman